// extracted by mini-css-extract-plugin
export default {"fileInput":"FormFileInput_fileInput__xrW7N"};